import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { IntegrationFormState } from "../../types";
import CredentialSelector from "./CredentialSelector";

interface TextDocumentFormProps {
  formData: IntegrationFormState;
  setFormData: (data: IntegrationFormState) => void;
}

const TextDocumentForm = ({ formData, setFormData }: TextDocumentFormProps) => {
  return (
    <>
      <div>
        <Label className="text-sm font-semibold">Context Endpoint *</Label>
        <Input
          type="text"
          placeholder="e.g., https://api.example.com/documents"
          value={formData.base_url || ""}
          onChange={(e) => setFormData({ ...formData, base_url: e.target.value })}
          className="mt-2"
        />
        <p className="text-xs text-gray-500 mt-1">
          Must be a valid URL (e.g., https://example.com)
        </p>
      </div>

      <div>
        <Label className="text-sm font-semibold">Access *</Label>
        <div className="flex gap-3 mt-2">
          <button
            type="button"
            onClick={() => setFormData({ ...formData, access_type: "public" })}
            className={`flex-1 px-4 py-2 rounded-lg border-2 text-sm font-medium transition-colors ${
              formData.access_type === "public"
                ? "border-[#4E9CFF] bg-[#4E9CFF]/10 text-[#4E9CFF]"
                : "border-gray-200 text-gray-600 hover:border-gray-300"
            }`}
          >
            Public
          </button>
          <button
            type="button"
            onClick={() => setFormData({ ...formData, access_type: "private" })}
            className={`flex-1 px-4 py-2 rounded-lg border-2 text-sm font-medium transition-colors ${
              formData.access_type === "private"
                ? "border-[#4E9CFF] bg-[#4E9CFF]/10 text-[#4E9CFF]"
                : "border-gray-200 text-gray-600 hover:border-gray-300"
            }`}
          >
            Private
          </button>
        </div>
      </div>

      {formData.access_type === "public" && (
        <div>
          <Label className="text-sm font-semibold">Custom Headers</Label>
          <Input
            type="text"
            placeholder="e.g., X-Custom-Header: value"
            value={formData.custom_headers || ""}
            onChange={(e) =>
              setFormData({ ...formData, custom_headers: e.target.value })
            }
            className="mt-2"
            autoComplete="off"
          />
        </div>
      )}

      {formData.access_type === "private" && (
        <CredentialSelector
          formData={formData}
          setFormData={setFormData}
        />
      )}
    </>
  );
};

export default TextDocumentForm;
